import { Legal, LegalList, Box, Container, Heading } from '@dapperlabs/core-fe';

export interface PrivacyContentProps {
  sections: Array<Legal>;
  title: string;
}

export const PrivacyContent = ({ title, sections }: PrivacyContentProps) => {
  return (
    <Container
      maxWidth={{ lg: '100%', sm: '100%' }}
      paddingTop={10}
      px={{ lg: '5%', sm: 2 }}
    >
      <Heading
        mb={['1rem', null, '1.5rem']}
        px='6'
        fontFamily='poster'
        fontSize='4.375rem'
        fontWeight='400'
      >
        {title}
      </Heading>
      <Box pb={4} px={2}>
        <LegalList legalList={sections} />
      </Box>
    </Container>
  );
};
